import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/sign_bg@2x.9ac900b.png';
const _withScopeId = n => (_pushScopeId("data-v-20e701d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "login",
  id: "Message"
};
const _hoisted_2 = {
  class: "min"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logins"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})])], -1));
const _hoisted_4 = {
  class: "signIn"
};
const _hoisted_5 = {
  class: "lable"
};
const _hoisted_6 = {
  class: "lable"
};
const _hoisted_7 = {
  class: "lable"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lable"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "submit",
  type: "submit"
}, "登陆")], -1));
const _hoisted_10 = {
  class: "lable",
  style: {
    "justify-content": "center"
  }
};
import { ref } from 'vue';
import nav_header from '../components/nav_header.vue';
import msgs from '../components/prompt.vue';
import { login, codeImg } from '../util/http';

import { useRouter } from 'vue-router';
import { reactive, onBeforeMount } from 'vue';
export default {
  __name: 'domlogin',
  props: {
    shows: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    let codeImage = ref('');
    let msg = ref('账号不能为空');
    let show = ref(false);
    let query = reactive({
      mobile: '',
      password: '',
      key: ''
    });
    onBeforeMount(() => {
      repeatImg();
    });
    let returnUp = () => {
      router.push({
        path: `/`
      });
    };
    let timeout;
    let msgss = () => {
      show.value = true;
      if (show.value) {
        timeout = setTimeout(() => {
          show.value = false;
        }, 1000);
      } else {
        clearTimeout(timeout);
      }
    };
    let onSubmit = e => {
      e.preventDefault();
      if (query.mobile == '' || query.password == '') {
        msgss();
        msg.value = '账号密码不能为空';
        repeatImg();
      } else {
        show.value = false;
        logins(query);
      }
    };
    let showSelect = () => {
      emits('update:shows', false);
    };
    let logins = data => {
      login(data).then(res => {
        if (res.message == "成功") {
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          localStorage.setItem('chat', JSON.stringify(res.data.chat));
          localStorage.setItem(res.data.token_type, res.data.token);
          router.push({
            path: `/`
          });
          emits('update:shows', false);
        } else {
          msgss();
          msg.value = res.message;
          repeatImg();
        }
      });
    };
    let repeatImg = () => {
      codeImg().then(res => {
        codeImage.value = res.data.image;
        query.key = res.data.key;
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return __props.shows ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("form", {
        action: "",
        onSubmit: _cache[4] || (_cache[4] = (...args) => _unref(onSubmit) && _unref(onSubmit)(...args))
      }, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(query).mobile = $event),
        placeholder: "请输入账号"
      }, null, 512), [[_vModelText, _unref(query).mobile]])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(query).password = $event),
        placeholder: "请输入密码"
      }, null, 512), [[_vModelText, _unref(query).password]])]), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
        class: "code",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(query).code = $event),
        placeholder: "请输入验证码"
      }, null, 512), [[_vModelText, _unref(query).code]]), _createElementVNode("div", {
        class: "img",
        onClick: _cache[3] || (_cache[3] = (...args) => _unref(repeatImg) && _unref(repeatImg)(...args))
      }, [_createElementVNode("img", {
        src: _unref(codeImage),
        alt: ""
      }, null, 8, _hoisted_8)])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_router_link, {
        to: "/register"
      }, {
        default: _withCtx(() => [_createTextVNode(" 立即注册 ")]),
        _: 1
      })])], 32)])]), _createElementVNode("img", {
        onClick: _cache[5] || (_cache[5] = (...args) => _unref(showSelect) && _unref(showSelect)(...args)),
        style: {
          "height": "35px",
          "width": "34px"
        },
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAMAAABG8BK2AAAANlBMVEVHcEz///////////////////////////////////////////////////////////////////+GUsxbAAAAEXRSTlMABa9ZNeZE8dUSwhkkZpCXieQcDQAAAAJbSURBVFjDrZjZcsMgDEXNvnhL/v9nm0HgYJAU04GXzjT4gLaLYFnoofdDeuPeb2e8PHa9jI+wy8/39+HkHoYgVr6JIe1ThlD+zQyvxKOdsJAE+r2jtTLHxZfSWxAibFq9YuUrufIUdc01h202L+xhrhUU55WzTIu4A4SKZcZJeiiUOZEx3l6TiOCv2bdG/TA8m+ZXjiJ/pliQNCdkyv4kKfbM6VYUYLJ7mKQWIhpbP0OM3OPy08A5G7cNUi7OLRwr/M8OlS+sXLtZPvdu62fZguWoJsm7CSLF2oRhaUt56MXNv2pcIu8fps3EepnT41LQ/pCSzdeesU0SoZkem/XqT2W7mcXgFZMVQLTbSbEJvWciWnmZYnrvhBJ+cyuOzSGcgFWdMCXhkk0Hmuk1JytAW7tHscphZdBxCAo42X0+SH/FwnMoyiLSPA2uiWQFA4ek5HDsYNxrYTlZX1EdeYFrJVkIF4ejQMglVILmlMlzFPCth4zdWIVjlXGDlHQlDXkOqa8BIt6VCcqhVVqk339gVkOdSA2GNWq7WgiSk43iXPyl0JzsYibgmWIcx8kBp9OvUDbNcXL6kcVwUb55GOhioEqzorCcXJqEUNwoDKcIBS5bDYXmFNnCRbSlkJxLRDFJ7ymLQDlfSUcOGN9TvvuR+AHTH3dQJr5N7bIf/LhDDt9IHL6p4zPE4du3Alt0eCtgzb3Nr1uBkcZE6EA2JpPapElN2/9aSNG1kLMa2knt9axmf9bVY9JFaNa1bNYlcdaVddYFetZ1ftrjwqynjmkPL7OegeY9Sg0/kf0BIlpZFP6l6E8AAAAASUVORK5CYII=",
        alt: ""
      })])) : _createCommentVNode("", true);
    };
  }
};